import axios from "axios";

// Same-origin API resolution.
// Why: when the prod frontend is served from https://mymoneyhero.app but the
// build-time REACT_APP_BACKEND_URL points at the underlying Emergent slug
// (e.g. https://hero-score-audit.emergent.host), the browser treats those as
// different origins. With `withCredentials: true`, browsers refuse to store
// auth cookies on cross-origin responses unless the server returns a specific
// origin (we use `*`). Calling our own origin sidesteps the entire issue.
//
// Order of precedence:
//  1. Browser is at the live custom domain → use its origin (same-origin, cookies just work)
//  2. Build-time REACT_APP_BACKEND_URL (preview / dev / explicit override)
//  3. Empty string fallback (relative URLs)
function resolveBackend() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    // Production custom domains: call our own origin.
    if (host === "mymoneyhero.app" || host === "www.mymoneyhero.app") {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

const BACKEND = resolveBackend();

export const API = `${BACKEND}/api`;
const TOKEN_KEY = "mmh_access_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (t) => {
    try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
  },
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
